module.exports = __webpack_public_path__ + "img/glazing-simple.1f1213b.svg";